import {Expose, Type} from 'class-transformer'
import {AlertCircle} from 'react-feather'

import {Sku} from './Sku'

export class DamagedSummary {
  static type = 'damagedsummary'
  static typeDisplay = 'Damaged Summary'
  static icon = AlertCircle

  type = DamagedSummary.type
  typeDisplay = DamagedSummary.typeDisplay
  icon = DamagedSummary.icon

  guid: string = ''

  @Expose({name: 'num_units'})
  numUnits: number = 0

  @Type(() => Sku)
  sku?: Sku
}
